function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IranFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#F7FCFF",
      fillRule: "evenodd",
      d: "M0 3v18h24V3H0Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("mask", {
      id: "b",
      width: "24",
      height: "18",
      x: "0",
      y: "3",
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: 'luminance'
      },
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 3v18h24V3H0Z",
        clipRule: "evenodd"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#b)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#5EAA22",
        fillRule: "evenodd",
        d: "M0 3v6h24V3H0Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#E31D1C",
        fillRule: "evenodd",
        d: "M0 15v6h24v-6H0Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        stroke: "#F7FCFF",
        strokeWidth: ".5",
        d: "M.28 16.025h-1.706M.254 16.684H-.03v-.367h.595v-.3.668h.27v-.669M1.139 16.056v.631h-.28M3.206 16.025H1.501M1.483 16.7v-.391h.555v.378H2.6v-.378h-.29M3.233 16.684H2.95v-.367h.595v-.3.668h.27v-.669M4.118 16.056v.631h-.28M6.185 16.025H4.48M4.462 16.7v-.391h.555v.378h.561v-.378h-.29M6.16 16.684h-.283v-.367h.595v-.3.668h.27v-.669M7.045 16.056v.631h-.28M9.112 16.025H7.407M7.39 16.7v-.391h.554v.378h.561v-.378h-.29M9.086 16.684h-.282v-.367h.595v-.3.668h.27v-.669M9.971 16.056v.631h-.28M12.04 16.025h-1.706M10.316 16.7v-.391h.555v.378h.561v-.378h-.29M12.066 16.684h-.283v-.367h.595v-.3.668h.27v-.669M12.95 16.056v.631h-.28M15.018 16.025h-1.705M13.295 16.7v-.391h.555v.378h.561v-.378h-.29M15.045 16.684h-.283v-.367h.595v-.3.668h.27v-.669M15.93 16.056v.631h-.28M17.997 16.025h-1.705M16.274 16.7v-.391h.555v.378h.561v-.378h-.29M18.024 16.684h-.283v-.367h.595v-.3.668h.27v-.669M18.909 16.056v.631h-.28M20.976 16.025h-1.705M19.253 16.7v-.391h.555v.378h.561v-.378h-.29M20.95 16.684h-.282v-.367h.595v-.3.668h.27v-.669M21.835 16.056v.631h-.28M23.903 16.025h-1.705M22.18 16.7v-.391h.555v.378h.561v-.378h-.29M24.034 16.684h-.282v-.367h.595v-.3.668h.27v-.669M.28 6.875h-1.706M.254 7.535H-.03v-.368h.595v-.3.668h.27v-.669M1.139 6.906v.631h-.28M3.206 6.875H1.501M1.483 7.55V7.16h.555v.378H2.6V7.16h-.29M3.233 7.535H2.95v-.368h.595v-.3.668h.27v-.669M4.118 6.906v.631h-.28M6.185 6.875H4.48M4.462 7.55V7.16h.555v.378h.561V7.16h-.29M6.16 7.535h-.283v-.368h.595v-.3.668h.27v-.669M7.045 6.906v.631h-.28M9.112 6.875H7.407M7.39 7.55V7.16h.554v.378h.561V7.16h-.29M9.086 7.535h-.282v-.368h.595v-.3.668h.27v-.669M9.971 6.906v.631h-.28M12.04 6.875h-1.706M10.316 7.55V7.16h.555v.378h.561V7.16h-.29M12.066 7.535h-.283v-.368h.595v-.3.668h.27v-.669M12.95 6.906v.631h-.28M15.018 6.875h-1.705M13.295 7.55V7.16h.555v.378h.561V7.16h-.29M15.045 7.535h-.283v-.368h.595v-.3.668h.27v-.669M15.93 6.906v.631h-.28M17.997 6.875h-1.705M16.274 7.55V7.16h.555v.378h.561V7.16h-.29M18.024 7.535h-.283v-.368h.595v-.3.668h.27v-.669M18.909 6.906v.631h-.28M20.976 6.875h-1.705M19.253 7.55V7.16h.555v.378h.561V7.16h-.29M20.95 7.535h-.282v-.368h.595v-.3.668h.27v-.669M21.835 6.906v.631h-.28M23.903 6.875h-1.705M22.18 7.55V7.16h.555v.378h.561V7.16h-.29M24.034 7.535h-.282v-.368h.595v-.3.668h.27v-.669"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#E31D1C",
        fillRule: "evenodd",
        d: "M10.955 9.188s.32.168.648.168.658-.168.658-.168v.224s-.36.17-.68.17c-.318 0-.626-.17-.626-.17v-.225Zm-2.363 2.655c0-1.334 1.832-2.206 1.832-2.206s-1.059.568-1.059 2.15c0 1.582.55 2.268.55 2.268s-1.323-.879-1.323-2.212Zm6.178-.074c0-1.333-1.83-2.132-1.83-2.132s1.06.568 1.06 2.15c0 1.582-.55 2.268-.55 2.268s1.32-.952 1.32-2.286Zm-4.927.364c-.07-1.331 1.038-2.525 1.038-2.525s-.404.548-.32 2.129c.028.542.241 1.35.51 1.825V9.694h1.126v3.902c.27-.445.477-1.203.506-1.753.083-1.58-.301-2.235-.301-2.235s1.108 1.194 1.038 2.525c-.042.793-.652 1.632-1.139 2.18.237.053.554.118.99.204.009.048-.088.046-.281.041a6.188 6.188 0 0 0-.976.043c-.199.204-.337.324-.337.324s-.022-.03-.056-.07c-.034.04-.056.07-.056.07s-.138-.12-.337-.324a6.188 6.188 0 0 0-.975-.043c-.193.005-.29.007-.281-.041.436-.086.753-.15.99-.203-.487-.549-1.098-1.388-1.14-2.18Z",
        clipRule: "evenodd"
      })]
    })]
  })]
}));
//# sourceMappingURL=Iran.js.map